<template>
  <div class="rebind">
    <div class="container">
      <BindInfo type="rebind"/>
      <ContactInfo ref="contactRef"/>
    </div>
    <div class="bind-btn">
      <van-button type="primary" class="cancel" round @click="cancel">取消</van-button>
      <van-button type="primary" class="bind" round @click="submit">重新绑定</van-button>
    </div>
    <IdentifyResult :dialog-visible="dialogVisible" type="rebind" @closeDialog="dialogVisible = false"/>
  </div>
</template>

<script>
import BindInfo from './components/bind-info.vue'
import ContactInfo from './components/contact-info.vue'
import IdentifyResult from './components/identify-result'
export default {
  name: 'Rebind',
  components: {
    BindInfo,
    ContactInfo,
    IdentifyResult
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    submit() {
      const contactInfo = this.$refs.contactRef.getContactInfo()
      console.log(contactInfo)
      if (!contactInfo) return
      this.dialogVisible = true
    },
    cancel() {
      this.$router.push({ name: 'UserHome' })
    }
  }
}
</script>

<style lang="scss" scoped>
.rebind {
  background: #f9f9f9;
  height: 100vh;
  .container {
    background: #f9f9f9;
    padding: 0 24px 230px;
  }
  .bind-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    background: #fff;
    width: 100%;
    height: 186px;
    padding-top: 30px;
    text-align: center;
    .cancel {
      width: 254px;
      height: 96px;
      background-image: linear-gradient(120deg, #EDF3FF 0%, #E9F0FF 97%);
      font-size: 30px;
      color: #242424;
      border: none;
      margin-right: 40px;
    }
    .bind {
      width: 392px;
      height: 96px;
      font-size: 30px;
      background-image: linear-gradient(120deg, #4F4CFB 0%, #376FF4 97%);
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/bind/rebind.vue